import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, IconButton, Drawer,
  Card, CardHeader, CardText, CircularProgress, Dialog, FlatButton, TextField
} from "material-ui";
import Editar from "material-ui/svg-icons/image/edit";
import Observacion from "material-ui/svg-icons/action/visibility";
import Caracteristicas from "material-ui/svg-icons/action/assignment";
import Detalle from "material-ui/svg-icons/editor/format-list-bulleted";
import { cerrarModalDetalle, cargarDetallePaquete, cerrarModalCaracteristicas, cargarCaracteristicasPaquetes, cargarModalObservacion, cerrarModalObservacion, CambiarObservacion, GuardarObservacion, OpenEditarPrestacion, SeleccionarPrestacionEliminar, SeleccionarPrestacionEditar } from "./actions";
//import EliminarPrestacionForm from "../EliminarPrestacionForm/view";
//import EditarPrestacionForm from "../EditarPrestacionForm/view";
//import { ObtenerDetallePrestacionEdicion, ObtenerCentrosAtencionPorPrestacion } from "../EditarPrestacionForm/actions";
//import { ObtenerDetallePrestacionEliminacion, ObtenerCentrosAtencionPorPrestacionEli } from "../EliminarPrestacionForm/actions";


import styles from "../../styles/styles";
import PaginacionBd from "../../PaginacionV2/view";
import TablePaginationCustomAG from "../TablePagination/view";


class GrillaBusquedaAG extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      listaItems: [],
    }
  }

  componentWillMount() { }

  EditEnabled = (idPrestacion/*, CodPrestacion, CodProf, TipoAtencion*/) => {
    let result = false;
    /*this.props.prestacionesSolicitud.forEach((item) => {
      if (idPrestacion === item.IDPRESTACION && CodPrestacion === item.COD_PRESTADOR
        && (CodProf === item.PROF_CCOD || item.PROF_CCOD === "**") && (TipoAtencion === item.TIPO_ATENCION || typeof item.TIPO_ATENCION === "undefined")) {
        result = true;
      }
    });*/
    //result = true;
    return result;
  }
  OpenEliminarPrestacion = (idPrestacion) => {
    this.props.dispatch(SeleccionarPrestacionEliminar(idPrestacion));
    //this.props.dispatch(ObtenerCentrosAtencionPorPrestacionEli(idPrestacion, CodPrestacion, CodProf, TipoAtencion, this.props.tipoArancel, this.props.rutInstitucion, this.props.isapre));
    //this.props.dispatch(ObtenerDetallePrestacionEliminacion(idPrestacion, this.props.isapre, OpenEliminarPrestacion));
  }

  OpenEditarPrestacion = (idPrestacion) => {
    this.props.dispatch(SeleccionarPrestacionEditar(idPrestacion));
    // this.props.dispatch(ObtenerCentrosAtencionPorPrestacion(idPrestacion, CodPrestacion, CodProf, TipoAtencion, this.props.tipoArancel, this.props.rutInstitucion, this.props.isapre));
    // this.props.dispatch(ObtenerDetallePrestacionEdicion(idPrestacion, this.props.isapre, OpenEditarPrestacion));
  }

  OpenVerObservacion = (idPrestacion) => {
    const result = this.props.paquetes.filter(paquete => paquete.ID_PAQUETE === idPrestacion);
    let observacion = result[0].OBSERVACION;
    let idPaquete = result[0].ID_PAQUETE;
    /*if (this.props.observacionesGuardadas.length > 0) {
      var myArray = this.props.observacionesGuardadas;
      var newArray = myArray.filter((item) => (item.idPaquete === idPrestacion));
      console.log(newArray)
      if (newArray.length > 0) {
        observacion = newArray[0].observacion;
      }
    }*/
    this.props.dispatch(cargarModalObservacion(true, observacion, idPaquete));
    // this.props.dispatch(ObtenerCentrosAtencionPorPrestacion(idPrestacion, CodPrestacion, CodProf, TipoAtencion, this.props.tipoArancel, this.props.rutInstitucion, this.props.isapre));
    // this.props.dispatch(ObtenerDetallePrestacionEdicion(idPrestacion, this.props.isapre, OpenEditarPrestacion));
  }

  OpenCaracteristicasPaquete = (idPaquete) => {
    this.props.dispatch(cargarCaracteristicasPaquetes(idPaquete));
  }

  OpenDetallePaquete = (idPaquete, totalClinica, totalHMQ, totalMonto) => {
    this.props.dispatch(cargarDetallePaquete(idPaquete, totalClinica, totalHMQ, totalMonto));
  }

  CerrarModalObservacion = () => {
    this.props.dispatch(cerrarModalObservacion(false));
    //this.props.dispatch(CambiarObservacion(null));
  }

  CerrarModalCaracteristicas = () => {
    this.props.dispatch(cerrarModalCaracteristicas(false));
    //this.props.dispatch(CambiarObservacion(null));
  }

  CerrarModalDetalle = () => {
    this.props.dispatch(cerrarModalDetalle(false));
    //this.props.dispatch(CambiarObservacion(null));
  }


  CambiarObservacion = (event) => {
    this.props.dispatch(CambiarObservacion(event.target.value));
  }

  GuardarObservacion = () => {
    this.props.dispatch(GuardarObservacion(this.props.observacion, this.props.idPaqueteObservacion));
    this.props.dispatch(cerrarModalObservacion(false));
  }


  render() {

    const menuListprestaciones = [];
    const menuListCaracteristicas = [];
    const menuListDetalle = [];

    this.props.arancelGES.map((row, index) => (
      menuListprestaciones.push((
        <TableRow key={index}>
          <TableRowColumn id={row.ID} style={{ visibility: "hidden" }}>{row.ID}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP1}>{row.PRGE_CCOD_PRESTADOR}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP2}>{row.GLOSA_PRESTACION}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP3}>{row.PRGE_CCOD}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP4}>{row.PROF_CCOD}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP5}>{(row.ARPR_MARANCEL).toLocaleString('de-DE')}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP6}>{row.UNID_CCOD}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP7}>{row.DEPS_MARCA_AMBHOS === 'A' ? 'AMBULATORIA' : 'HOSPITALARIA'}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP8}>{(new Date(row.ARPR_FINICIAL)).toLocaleDateString("en-GB", { timeZone: "UTC" })}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP2}>{row.PRSA_CCOD}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP10}>{row.PRFI_CCOD_INTSAN}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP11}>{row.SUBCANASTA}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP12}>{row.PRGE_TIPO_PRESTACION}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP13}>{row.CENTRO_ATENCION}</TableRowColumn>
          {/*<TableRowColumn style={styles.datoTablaBusquedaP14}>
            {!this.EditEnabled(row.ID_PAQUETE) ?
              <IconButton
                iconStyle={styles.svgStyleResultado}
                style={styles.iconStyleResultado}
                // disabled={this.EditEnabled(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION)}
                onClick={() => this.OpenEditarPrestacion(row.ID_PAQUETE)}
              >
                <Editar />
              </IconButton> : null}
          </TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP14}>
            {!this.EditEnabled(row.ID_PAQUETE) ?
              <IconButton
                iconStyle={styles.svgStyleResultado}
                style={styles.iconStyleResultado}
                // disabled={this.EditEnabled(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION)}
                onClick={() => this.OpenVerObservacion(row.ID_PAQUETE)}
              >
                <Observacion />
              </IconButton> : null}
          </TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP14}>
            {!this.EditEnabled(row.ID_PAQUETE) ?
              <IconButton
                iconStyle={styles.svgStyleResultado}
                style={styles.iconStyleResultado}
                // disabled={this.EditEnabled(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION)}
                onClick={() => this.OpenCaracteristicasPaquete(row.ID_PAQUETE)}
              >
                <Caracteristicas />
              </IconButton> : null}
          </TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP14}>
            {!this.EditEnabled(row.ID_PAQUETE) ?
              <IconButton
                iconStyle={styles.svgStyleResultado}
                style={styles.iconStyleResultado}
                // disabled={this.EditEnabled(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION)}
                onClick={() => this.OpenDetallePaquete(row.ID_PAQUETE, row.TOTAL_CLINICA, row.TOTAL_HMQ, row.PAQU_MONTO_TOTAL)}
              >
                <Detalle />
              </IconButton> : null}
            </TableRowColumn>*/}
        </TableRow>
      ))
    ));

    this.props.caracteristicasPaquete.map((row, index) => (
      menuListCaracteristicas.push((
        <TableRow key={index}>
          <TableRowColumn style={styles.datoTablaCaracteristicasP1}>{row.Tipo}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaCaracteristicasP1}>{row.Descripcion}</TableRowColumn>
        </TableRow>
      ))
    ));

    this.props.detallePaquete.map((row, index) => (
      menuListDetalle.push((
        <TableRow key={index}>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.TIPO_ATENCION}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.COD_PRES_ISAP}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.COD_PRES_PREST}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.GLOSA_PRES_PREST}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.ITEM_IMED}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.COD_PROF}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.CANT_PRES}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.MONTO_UNITARIO}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.UNIDAD}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.MEDICO_U_HOTELERIA}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.BONO_RUT}</TableRowColumn>
        </TableRow>
      ))
    ));

    return (
      <div>
        <div style={{ padding: "5px" }}>
          <Card
            initiallyExpanded
            zDepth={0}
          >
            <CardHeader
              actAsExpander
              showExpandableButton
              iconStyle={{ height: 20, width: 20, color: "#212121" }}
            /*style={{
              paddingTop: "0px", paddingBottom: "0px", maxWidth: "1500px", overflow: "auto",
            }}*/
            >
              <div style={styles.h1}>Resultado Búsqueda</div>
            </CardHeader>
            <CardText
              expandable
            /*style={{
              paddingTop: "0px", paddingBottom: "0px", maxWidth: "1500px", overflow: "auto",
            }}*/
            >
              {!this.props.loading ?
                <div>
                  {(!this.props.arancelGES || this.props.arancelGES.length === 0) ?
                    <span style={{ textAlign: "left" }}>
                      {this.props.loading != null ? "No se encontraron resultados" : "-"}
                    </span>
                    :
                    <div>
                      {<div id="tablaBusquedaPaquetes" style={{ overflow: "auto" }}>
                        <div style={{ width: "fit-content", overflowX: "auto", textAlign: "left" }}>
                          <Table
                            key="tablaBusquedaPaquetes"
                            fixedHeader
                            selectable={false}
                            style={{ overflow: "hidden" }}
                          >
                            <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                              <TableRow selectable={false}>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Código<br />Prestador</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP2}>Glosa<br />Prestación</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP3}>Código<br />Isapre/GES</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP4}>Código<br />Profesional</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP5}>Valor</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP6}>Unidad</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP7}>Tipo<br />Atención</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP8}>Inicio<br />Vigencia</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP2}>Problema<br />Salud</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP10}>Intervención<br />Sanitaria</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP11}>Sub<br />Canasta</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP12}>Tipo<br />Prestación</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP13}>Centro<br />Atención</TableHeaderColumn>
                              </TableRow>
                            </TableHeader>
                            <TableBody
                              id="tablaBodyBusquedaPaquetes"
                              displayRowCheckbox={false}
                              deselectOnClickaway={false}
                              stripedRows
                            >
                              {menuListprestaciones}
                            </TableBody>
                          </Table>
                        </div>
                      </div>}
                      {
                        <TablePaginationCustomAG
                          key="pag_tablaBodyBusquedaPaquetes"
                          rowsPerPageDefault={5} // [5,10,15,20,25]
                          totalRows={this.props.totalPage}
                          pageDefault={1}
                          idTableBody="tablaBodyBusquedaPaquetes"
                          showRowsPerPage={false}
                          labelStyleBtnPage={{ fontSize: "11px" }}
                          overlayStyleBtnPage={{ borderRadius: 20 }}
                          rippleStyleBtnPage={{ borderRadius: 20 }}
                          buttonStyleBtnPage={{ borderRadius: 20 }}
                          styleBtnPage={{
                            paddingLeft: 0,
                            paddingRight: 0,
                            paddingTop: 0,
                            paddingBottom: 0,
                            height: 25,
                            width: "45px",
                            minWidth: "45px",
                            borderRadius: 20,
                            marginRight: 5,
                          }}

                          labelStyleRowsPerPage={styles.h4}
                          underlineStyleRowsPerPage={styles.underlineSelectField}
                          iconStyleRowsPerPage={styles.iconSelectField}
                          menuItemStyleRowsPerPage={styles.menuItemStyleSelectField}
                          selectedMenuItemStyleRowsPerPage={styles.selectedMenuItemSelectField}
                          styleRowsPerPage={styles.selectFiledStyle}
                        />}
                    </div>
                  }
                </div>
                :
                <CircularProgress />
              }
            </CardText>
          </Card>
        </div>
        {/*<Drawer
          width="100%"
          openSecondary
          open={this.props.modalEliminarPrestacion}
          docked={false}
        >
          {(this.props.modalEliminarPrestacion) ?
            <EliminarPrestacionForm CambiosSinGuardar={this.props.CambiosSinGuardar} />
            : null}
        </Drawer>

        <Drawer
          width="100%"
          openSecondary
          open={this.props.modalEditarPrestacion}
          docked={false}
        >
          {(this.props.modalEditarPrestacion) ?
            <EditarPrestacionForm CambiosSinGuardar={this.props.CambiosSinGuardar} />
            : null}
        </Drawer>*/}

        {this.props.openModal ?
          <Dialog
            key="modalobservacion"
            actions={[/*
              <FlatButton
                label="Guardar"
                secondary
                onClick={this.GuardarObservacion}
              />,*/
              <FlatButton
                label="Cerrar"
                secondary
                onClick={this.CerrarModalObservacion}
              />]}
            modal
            open={this.props.openModal}
            style={{ width: "100%", fontSize: "13px" }}
          >
            <div style={styles.h1}>Observación
            </div>
            <div className="row" style={{ paddingBottom: 25 }}></div>
            <TextField
              name="pq_observacion"
              id="pq_observacion"
              hintStyle={{ top: "3px", left: "3px", color: "rgba(0, 0, 0, 0.4)" }}
              underlineStyle={styles.underlineSelectField}
              inputStyle={styles.h4}
              value={this.props.observacion || ""}
              //onChange={this.CambiarObservacion}
              style={styles.textFieldSolicitudObservacion}
              multiLine
              rows={4}
              rowsMax={4}
              maxLength={400}
            />
          </Dialog> : null}

        {this.props.openModalCaracteristicas ?
          <Dialog
            key="modalcaracteristicas"
            actions={[
              <FlatButton
                label="Cerrar"
                secondary
                onClick={this.CerrarModalCaracteristicas}
              />]}
            modal
            open={this.props.openModalCaracteristicas}
            style={{ width: "100%", fontSize: "13px" }}
          >
            <div style={styles.h1}>Características
            </div>
            <div className="row" style={{ paddingBottom: 25 }}></div>
            <div id="tablaModalCaracteristicas" style={{ overflow: "auto" }}>
              <div style={{ width: "fit-content", overflowX: "auto", textAlign: "left" }}>
                <Table
                  key="tablaModalCaracteristicas"
                  fixedHeader
                  selectable={false}
                  style={{ overflow: "hidden" }}
                >
                  <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                    <TableRow selectable={false}>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Tipo Atributo</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP2}>Descripción</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    id="tablaBodyModalCaracteristicas"
                    displayRowCheckbox={false}
                    deselectOnClickaway={false}
                    stripedRows
                  >
                    {menuListCaracteristicas}
                  </TableBody>
                </Table>
              </div>
            </div>
          </Dialog> : null}

        {this.props.openModalDetalle ?
          <Dialog
            key="modaldetalle"
            actions={[
              <FlatButton
                label="Cerrar"
                secondary
                onClick={this.CerrarModalDetalle}
              />]}
            modal
            open={this.props.openModalDetalle}
            style={{ width: "100%", fontSize: "13px" }}
          >
            <div style={styles.h1}>Prestaciones en el Paquete
            </div>
            <div className="row" style={{ paddingBottom: 25 }}></div>
            <div>Valor Total Clinica: ${this.props.totalClinica}</div>
            <div>Valor Total HMQ: ${this.props.totalHMQ}</div>
            <div>Valor Total Paquete: ${this.props.totalMonto}</div>
            <div className="row" style={{ paddingBottom: 25 }}></div>
            <div id="tablaModalDetalle" style={{ overflow: "auto" }}>
              <div style={{ width: "fit-content", overflowX: "auto", textAlign: "left" }}>
                <Table
                  key="tablaModalDetalle"
                  fixedHeader
                  selectable={false}
                  style={{ overflow: "hidden" }}
                >
                  <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                    <TableRow selectable={false}>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Tipo Atención</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Código<br />Isapre</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Código<br />Prestador</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Glosa<br />Prestador</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Item IMED</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Código<br />Profesional</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Cantidad</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Monto Unitario</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Unidad</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Médico u Hotelería</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Bono RUT</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    id="tablaBodyModalDetalle"
                    displayRowCheckbox={false}
                    deselectOnClickaway={false}
                    stripedRows
                  >
                    {menuListDetalle}
                  </TableBody>
                </Table>
              </div>
            </div>
          </Dialog> : null}
      </div>
    );
  }
}

GrillaBusquedaAG.defaultProps = {
  rutInstitucion: null,
  loading: null,
  openModal: false,
};

GrillaBusquedaAG.propTypes = {
  arancelGES: PropTypes.array.isRequired,
  caracteristicasPaquete: PropTypes.array.isRequired,
  detallePaquete: PropTypes.array.isRequired,
  modalEditarPrestacion: PropTypes.bool.isRequired,
  modalEliminarPrestacion: PropTypes.bool.isRequired,
  // idPrestacionEditar: PropTypes.number.isRequired,
  // idPrestacionEliminar: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  tipoArancel: PropTypes.number.isRequired,
  rutInstitucion: PropTypes.number,
  isapre: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  CambiosSinGuardar: PropTypes.func.isRequired,
  prestacionesSolicitud: PropTypes.array.isRequired,
  listaItems: PropTypes.array.isRequired,
  prestacionesPP: PropTypes.array,
  openModal: PropTypes.bool,
  openModalCaracteristicas: PropTypes.bool,
  openModalDetalle: PropTypes.bool,
  observacion: PropTypes.string,
  idPaqueteObservacion: PropTypes.number,
  totalClinica: PropTypes.number,
  totalHMQ: PropTypes.number,
  totalMonto: PropTypes.number,
  totalPage: PropTypes.number,
  //observacionesGuardadas: PropTypes.any,
};

const mapStateToProps = (state) => ({
  arancelGES: state.filtroBusquedaAG.arancelGES,
  modalEditarPrestacion: state.grillaBusquedaPQ.modalEditarPrestacion,
  openModal: state.grillaBusquedaPQ.openModal,
  openModalCaracteristicas: state.grillaBusquedaPQ.openModalCaracteristicas,
  openModalDetalle: state.grillaBusquedaPQ.openModalDetalle,
  observacion: state.grillaBusquedaPQ.observacion,
  caracteristicasPaquete: state.grillaBusquedaPQ.caracteristicasPaquete,
  detallePaquete: state.grillaBusquedaPQ.detallePaquete,
  idPaqueteObservacion: state.grillaBusquedaPQ.idPaqueteObservacion,
  totalClinica: state.grillaBusquedaPQ.totalClinica,
  totalHMQ: state.grillaBusquedaPQ.totalHMQ,
  totalMonto: state.grillaBusquedaPQ.totalMonto,
  //observacionesGuardadas: state.grillaBusquedaPQ.observacionesGuardadas,
  caracteristicasPaquete: state.grillaBusquedaPQ.caracteristicasPaquete,
  // idPrestacionEditar: state.grillaBusqueda.idPrestacionEditar,
  // idPrestacionEliminar: state.grillaBusqueda.idPrestacionEliminar,
  loading: state.filtroBusqueda.loading,
  tipoArancel: state.global.filtros_CAT.tipoArancel || 0,
  rutInstitucion: state.global.rutInstitucion,
  isapre: state.global.isapre,
  prestacionesSolicitud: state.grillaSolicitud.prestacionesSolicitud,
  prestacionesPP: state.paginacionState.prestaciopnesPP,
  tablaBody: state.paginacionState.tablaBody,
  totalPage: state.filtroBusquedaAG.pageSize,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(GrillaBusquedaAG);
